import { createScopedInstanceAndLoader, getLanguage } from '@citrite/translate';
import { LocaleString } from '@sharefiledev/templates-pilet-sdk';

const instance = createScopedInstanceAndLoader({
	namespace: 'request-list-pilet',
	localesLoaderMap: {
		en: () => import('./locales/en.json'),
		es: () => import('./locales/es.json'),
		ja: () => import('./locales/ja.json'),
		de: () => import('./locales/de.json'),
		fr: () => import('./locales/fr.json'),
		'pt-BR': () => import('./locales/pt-BR.json'),
		it: () => import('./locales/it.json'),
		nl: () => import('./locales/nl.json'),
	},
	compatibilityJSON: 'v4',
});

export const { LocalizationLoader } = instance;
export { getLanguage };

export const t: (str: string, opts?: any) => string = instance.t;

type Locales = 'en' | 'es' | 'de' | 'fr' | 'it' | 'ja' | 'nl' | 'pt-BR';

/**
 * Get a localized string in format accepted by template pilet
 * @param stringKey
 * @returns
 */
export function getLocaleString(stringKey: string): LocaleString {
	const retVal: LocaleString = {};
	retVal[getLanguage() as Locales] = t(stringKey);
	return retVal;
}
